<template>
  <div>
    <el-dialog title="支付" custom-class="MyDialog" :visible.sync="isShowBankRransferDialog" :close-on-click-modal="false"
      @close="closeCashDataModal" width="1000px">
      <div class="PaytoSongShu">
        <div class="right_content">
          <b>{{ companyInfo.companyName }}</b>
          <b>银行账号：{{ companyInfo.bankAccount }}</b>
          <b>开户行：{{ companyInfo.bankName }}</b>
        </div>
      </div>
      <el-row>
        <el-col :span="24">
          <el-form :model="bankRransferForm" ref="bankRransferForm" label-width="100px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="转账金额：" prop="money">
                  <el-input v-model="bankRransferForm.money" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付时间：" prop="payTime" :rules="[
                  {
                    required: true,
                    message: '支付时间不能为空',
                    trigger: 'blur'
                  }
                ]">
                  <el-date-picker v-model="bankRransferForm.payTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
                    placeholder="请选择支付时间：">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="支付流水" prop="paySysNo">
              <el-input placeholder="请输入支付流水" v-model="bankRransferForm.paySysNo"></el-input>
            </el-form-item>
            <el-form-item label="支付凭证：" prop="fileList" :rules="[
              {
                required: bankRransferForm.fileUrl != '' ? false : true,
                message: '支付凭证不能为空'
              }
            ]">
              <div>
                <span>支持jpg/png格式，最佳尺寸1080x1920，大小不超过5MB</span>
                <a class="credential-instance" @click="previewImage">凭证实例</a>
              </div>
              <el-upload ref="upload" class="upload-demo" action="#" accept=".jpg,.jpeg,.png" :on-remove="handleRemove"
                :before-remove="beforeRemove" :on-change="handleSetUploadData" :on-preview="handlePictureCardPreview"
                multiple list-type="picture-card"  :limit="1" :auto-upload="false" :on-exceed="handleExceed"
                :file-list="fileList" :before-upload="handleBeforeUpload">
                <i class="el-icon-plus"></i>
                <!-- <el-button type="primary">点击上传</el-button> -->
              </el-upload>
            </el-form-item>
            <el-form-item label="支付备注：" prop="remark">
              <el-input type="textarea" v-model="bankRransferForm.remark" placeholder="请输入支付备注" maxlength="500"
                :autosize="{ minRows: 4, maxRows: 8 }" show-word-limit></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCashDataModal">取 消</el-button>
        <el-button type="primary" @click="submitPay('bankRransferForm')">支付</el-button>
      </span>
    </el-dialog>
    <el-dialog width="30%" :visible.sync="showImageDemo">
      <img class="preview-demo-image" src="@/assets/images/agent/demo.png" />
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { agentSingleBankPay } from "@/api/AccountInterface";
import { getBaseUrl } from "@/util/config";
import axios from "axios";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  data() {
    return {
      bankRransferForm: {
        money: "",
        payTime: "",
        paySysNo: "",
        remark: "",
        fileUrl: ""
      },
      rules: {
        payTime: [
          { required: true, message: "请选择支付时间", trigger: "blur" }
        ]
      },
      isShowBankRransferDialog: false,
      fileList: [],
      showImageDemo: false,
      campusId: LoginUserHelper.getUserInfo().campusId,
      dialogImageUrl: '',
      dialogVisible:false
    };
  },
  props: {
    cashDataModalVisible: {
      type: Boolean,
      default: false
    },
    formLabelAlign: {
      type: Object,
      default: {}
    },
    companyInfo:{
      type: Object,
      default: {}
    }
  },
  watch: {
    cashDataModalVisible: {
      handler(newValue, oldValue) {
        this.isShowBankRransferDialog = newValue;
        this.fileList = [];
      },
      immediate: true
    },
    formLabelAlign: {
      handler(newValue, oldValue) {
        if (newValue.elsePayMoney) {
          this.bankRransferForm.money = newValue.elsePayMoney;
        }
      },
      immediate: true
    }
  },
  mounted() {
    console.log(999);
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    // 取消
    closeCashDataModal() {
      this.$emit("closeCashDataModal");
    },
    // 支付
    submitPay(formName) {
      const list = [];
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.bankRransferForm.fileUrl != "") {
            list.push(this.bankRransferForm.fileUrl);
          }
          const { money, paySysNo, payTime, remark } = this.bankRransferForm;
          agentSingleBankPay({
            campusId: this.campusId,
            fileUrl: list,
            money: money,
            paySysNo: paySysNo,
            payTime: this.convertDateString(payTime),
            remark: remark
          }).then(ret => {
            if (ret.code === 0) {
              this.$message({
                message: "付款成功",
                type: "success"
              });
              this.$emit("cashDataModalSuccess");
            } else {
              this.$message.error(ret.message || "付款失败");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除图片
    handleRemove(file) {
      this.bankRransferForm.fileUrl = "";
      this.bankRransferForm.fileName = "";
    },
	//检验
	handleBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        //限制图片 格式、size、
        const isJPG = file.type === "image/jpeg";
        const isJPEG = file.type === "image/jpeg";
        const isGIF = file.type === "image/gif";
        const isPNG = file.type === "image/png";
        const isBmp = file.type === "image/bmp";
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!(isJPG || isGIF || isPNG || isJPEG || isBmp)) {
          this.$message.error(
            "只能上传JPG 、JPEG 、GIF、 PNG、 BMP格式的图片~"
          );
          // this.fileLength--;
          return reject(false);
        }
        if (!isLt5M) {
          this.$message.error("超过5M限制 不允许上传~");
          return reject(false);
        }
        return resolve(true);
      });
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleSetUploadData(item) {
      const isLt5M = item.size / 1024 / 1024 < 5
      if (!isLt5M) {
        this.$refs.upload.clearFiles()
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        })
        return false
      }
      let FormDatas = new FormData();
      FormDatas.append("file", item.raw);
      let BASE_URL = getBaseUrl();
      axios
        .post(`${BASE_URL}base/upload/uploadPicture?type=record`, FormDatas, {
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: LoginUserHelper.getUserToken()
          }
        })
        .then(res => {
          console.log("res", res);
          if (res.code == 0) {
            console.log("res.data", res.data);
            let { fileName, uploadPath } = res.data;
            this.bankRransferForm.fileName = fileName;
            this.bankRransferForm.fileUrl = uploadPath;
          } else {
            this.$message.error(res.message);
          }
        });
    },
    handleExceed() { },
    previewImage() {
      this.showImageDemo = true;
    },
    convertDateString(inputDateString) {
      // 创建一个Date对象，将给定的时间字符串作为参数
      let date = new Date(inputDateString);
      // 获取年份、月份、日期、小时、分钟和秒
      let year = date.getUTCFullYear();
      let month = date.getUTCMonth() + 1;
      let day = date.getUTCDate();
      let hours = date.getUTCHours();
      let minutes = date.getUTCMinutes();
      let seconds = date.getUTCSeconds();
      // 在每个数字前面添加"0"以保持格式一致
      month = (month < 10 ? "0" : "") + month;
      day = (day < 10 ? "0" : "") + day;
      hours = (hours < 10 ? "0" : "") + hours;
      minutes = (minutes < 10 ? "0" : "") + minutes;
      seconds = (seconds < 10 ? "0" : "") + seconds;
      // 返回格式化的日期字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.purchase-info {
  color: rgb(74, 131, 232);
  background: rgb(232, 243, 254);
  width: 95%;
  height: 80px;
  margin: 0 auto;
  border-radius: 10px;
  font-size: 14px;
  padding: 10px;
  overflow: hidden;
  margin-bottom: 20px;

  .textOne {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textTwo {
    width: 85%;
    height: 20px;
    margin: 10px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.PaytoSongShu {
  // padding-left: 24px;
  display: flex;
  margin-bottom: 20px;
  justify-content: center;

  .left_content {
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
      width: 120px;
      height: 120px;
    }
  }

  .right_content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    b {
      font-size: 18px;
      margin-bottom: 20px;
      // margin-left: 28px;
    }
  }
}

.credential-instance {
  text-decoration: underline;
  margin-left: 10px;
  color: #4A83E8;
  cursor: pointer;
}

.preview-demo-image {
  width: 100%;
}
</style>
